export default __webpack_public_path__ + "static/media/top1 1.f28891ee.png";